import * as types from './actionTypes';
//import * as certificateApi from '../api/certificate.api';
import * as baseApi from '../api/base.api';

export function dropFileCompleted(files) {
    return {
        type: types.CERTIFICATE_DROPPED,
        payload: files
    };
}

export function clientSecretsInitialize(clientSecrets) {
    return {
        type: types.CLIENTSECRET_INIT,
        payload: clientSecrets
    }
}

export function selectedRiziv(selectedIndex) {
    return {
        type: types.SELECTRIZIV,
        payload: selectedIndex
    }
}

export function initCompleted(state) {
    return {
        type: types.CERTIFICATE_INIT,
        payload: state
    };
}

export const uploadCertificate = (files, formData) => {
    return dispatch => {

        let form = formData || new FormData();
        for (var index = 0; index < files.length; index++) {
            var element = files[index];
            form.append('file', element);
        }

        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }
        dispatch(uploadStart());
        baseApi.postWithConfig('api/certificates/Upload', form, config)
            .then(
                function (response) {
                    // Success → dispatch normally
                    dispatch(uploadSuccess(response.data));
                },
                function (error) {
                    // ---- Extract status ----
                    var status = 0;
                    if (error && error.response && error.response.status) {
                        status = error.response.status;
                    } else if (error && error.status) {
                        status = error.status;
                    }
                    // ---- Extract useful message ----
                    var message = null;
                    if (error && error.response && error.response.data) {
                        var data = error.response.data;
                        if (typeof data === 'object') {
                            // Prefer message or detail field from backend
                            if (data.message && data.detail) {
                                message = data.message + ' — ' + data.detail;
                            } else if (data.message) {
                                message = data.message;
                            } else if (data.detail) {
                                message = data.detail;
                            } else if (data.error) {
                                message = data.error;
                            } else {
                                message = JSON.stringify(data);
                            }
                        } else if (typeof data === 'string') {
                            // Plain text from server
                            message = data;
                        }
                    }

                    // ---- Fallbacks ----
                    if (!message && error && error.message) {
                        message = error.message;
                    }
                    if (!message) {
                        message = 'Unexpected error';
                    }

                    // ---- Optional: limit message length (avoid huge blobs) ----
                    if (message.length > 500) {
                        message = message.substring(0, 497) + '...';
                    }

                    // ---- Build final text for display ----
                    var finalMessage = (status ? '[' + status + '] ' : '') + message;
                    dispatch(uploadFailure(finalMessage));
                }
            );
    };
};


const uploadStart = () => ({
    type: types.CERTIFICATE_UPLOAD_START,
    payload: {
        value:true
    }
});

const uploadSuccess = data => ({
    type: types.CERTIFICATE_UPLOAD,
    payload: {
        data
    }
});


const uploadFailure = error => ({
    type: types.CERTIFICATE_UPLOAD_ERROR,
    payload: {
        error
    }
});